import ReactVivus from 'react-vivus';
import animatedAvatarTwoTones from './avatar-two-tones.svg';
import stopwatchTimer from './stopwatch-timer.svg';

export const AvatarTwoTones = ({ strokeColor, toneColor1, toneColor2, size }) => {
  const primaryColor = '#2176CD';
  const outerStroke = strokeColor || `${primaryColor}80`;
  const innerStroke = strokeColor || `${primaryColor}`;
  const tone1 = toneColor1 || `${primaryColor}90`;
  const tone2 = toneColor2 || `${primaryColor}40`;
  const avatarSize = size || '32px';

  return (
    <svg id="avatar-two-tones" width={avatarSize} height="auto" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g id="avatar" transform="translate(-1407 -182)">
        <circle
          id="Ellipse_16"
          data-name="Ellipse 16"
          cx="15"
          cy="15"
          r="15"
          transform="translate(1408 183)"
          fill={tone2}
          stroke={outerStroke}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <g id="Group_49" data-name="Group 49">
          <circle
            id="Ellipse_17"
            data-name="Ellipse 17"
            cx="4.565"
            cy="4.565"
            r="4.565"
            transform="translate(1418.435 192.13)"
            fill={tone1}
            stroke={innerStroke}
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <path
            id="Path_53"
            data-name="Path 53"
            d="M1423,213a14.928,14.928,0,0,0,9.4-3.323,9.773,9.773,0,0,0-18.808,0A14.928,14.928,0,0,0,1423,213Z"
            fill={tone1}
            stroke={innerStroke}
            stroke-miterlimit="10"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const AvatarTwoTonesAnimated = () => {
  return (
    <ReactVivus
      id="foo"
      option={{
        file: animatedAvatarTwoTones,
        animTimingFunction: 'EASE',
        type: 'delayed',
        onReady: myVivus => {
          myVivus.el.setAttribute('style', 'fill-opacity: 0;');
        },
      }}
      style={{ width: '5em' }}
      callback={myVivus => {
        myVivus.el.setAttribute('style', 'fill-opacity: 1; transition: fill-opacity 1s;');
      }}
    />
  );
};

export const StopwatchTimerAnimated = ({ fill, stroke, strokeWidth, fillTransition, strokeTransition }) => {
  return (
    <ReactVivus
      id="stopWatchTimerAnimated"
      option={{
        file: stopwatchTimer,
        pathTimingFunction: 'EASE',
        type: 'sync',
        duration: 150,
        onReady: myVivus => {
          fill && myVivus.el.firstElementChild.setAttribute('fill', fill);
          stroke && myVivus.el.firstElementChild.setAttribute('stroke', stroke);
          strokeWidth && myVivus.el.firstElementChild.setAttribute('stroke-width', strokeWidth);
          fillTransition && myVivus.el.setAttribute('style', 'fill-opacity: 0;');
        },
      }}
      style={{ width: '5em' }}
      callback={myVivus => {
        const transitions = [];
        fillTransition && transitions.push('fill-opacity: 1;');
        strokeTransition && transitions.push('stroke-opacity: 0;');

        !transitions.isEmpty() && myVivus.el.firstElementChild.setAttribute('style', `transition: all .5s; ${transitions.join(' ')}`);
      }}
    />
  );
};
